import React from "react";
import "./boostyoursavingscard.scss";
import { Card, Col } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
export const BoostYourSavingsCard = (props) => {
  return (
    <Card className="living-standards-card-container">
      {props.headIconName ? (
        <Col
          xs={3}
          md={1}
          sm={2}
          lg={4}
          className="d-flex justify-content-center"
        >
          <span
            className={
              props.headIconName === "minimum"
                ? "big-icon minimum-icon"
                : props.headIconName === "moderate"
                  ? "big-icon moderate-icon"
                  : "big-icon comfortable-icon"
            }
          >
            <Icons
              iconname={props.headIconName}
              variant={props.headIconVariant}
            />
          </span>
        </Col>
      ) : (
        ""
      )}
      <div className="li-title">
        {props.pageTitle ? props.pageTitle : props.title}
        <div className="text-start">
          <span className="your-goals-header_edit">{props.value}</span>
        </div>
      </div>
      <p className="card-sub-title mt-3 mb-2">{props.subTitle}</p>
      <Buttons
        className="tertiary text-start"
        name={props.btnName ? "Back" : "View more"}
        handleClick={() => props.onClickHandler(props.cardData, props.btnName)}
      />
    </Card>
  );
};
